export const isIE = (typeof window !== "undefined" && !!window.document["documentMode"]) || false;
